// Module
var code = `<div ng-if="showButton"><a ng-click="loadUrl(addLink, '_blank')" rel="nofollow"><img ng-click="logClick()" ng-src="{{:: 'linkedin.linkedin_profile_button.add_to_profile_img_src' | translate }}" style="width:90px;height:auto" alt="{{:: 'linkedin.linkedin_profile_button.add_to_profile_alt' | translate }}"></a></div>`;
// Exports
export default code;